import ReactDOM from 'react-dom';
import App from 'App';
import 'i18n';
import 'antd/dist/antd.min.css';
import 'App.scss';

ReactDOM.render(<App />, document.getElementById('root'));
